import { createContext } from 'react';

export const defaultStates = {
  updateContext: 0,
  enableCart: false,
  enableFooter: false,
  cart: null,
  next: {
    title: 'Next',
    action: () => console.log('next button is clicked'),
    enable: true,
    show: true,
  },
  checkoutBtn: { show: true },
  handleBillPayToogle: false,
  handsetPurchased: false,
  standaloneCart: false,
  enableLogout: false,
  insuranceTermsChecked: { status: false, id: 0 },
  loginButton: false,
  displayLogin: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_CART':
      return { ...state, updateContext: state.updateContext + 1 };
    case 'SHOW_CART': {
      return { ...state, enableCart: action.payload, updateContext: state.updateContext + 1 };
    }
    case 'SET_CART': {
      return { ...state, cart: action.payload, updateContext: state.updateContext + 1 };
    }
    case 'ENABLE_FOOTER': {
      return { ...state, enableFooter: action.payload };
    }
    case 'ENABLE_LOGOUT': {
      return { ...state, enableLogout: action.payload };
    }
    case 'ENABLE_LOGIN_BUTTON': {
      return { ...state, loginButton: action.payload };
    }
    case 'DISPLAY_LOGIN': {
      return { ...state, displayLogin: action.payload };
    }
    case 'SET_NEXT_BUTTON_METHOD': {
      return {
        ...state,
        next: { ...state?.next, ...action?.payload },
      };
    }
    case 'SET_CHECKOUT_BUTTON': {
      return {
        ...state,
        checkoutBtn: { ...action.payload },
      };
    }
    case 'SET_BILLPAY_TOGGLE': {
      return {
        ...state,
        handleBillPayToogle: action.payload,
      };
    }
    case 'HANDSET_PURCHASED': {
      return {
        ...state,
        handsetPurchased: action.payload,
      };
    }
    // case 'SET_STANDALONE_CART': {
    //   return {
    //     ...state,
    //     standaloneCart: action.payload,
    //   };
    // }
    case 'LOGIN':
      return { ...state, loginState: true, loginUserEmail: action.payload.email };

    case 'SET_INSURANCE_TERMS_CHECKED': {
      return {
        ...state,
        insuranceTermsChecked: { ...state.insuranceTermsChecked, ...action.payload },
      };
    }
    default:
      break;
  }
};

const RootContext = createContext();

export default RootContext;
